import Octicon, { getIconByName } from '@github/octicons-react'; //https://octicons.github.com/
import * as React from 'react';


export class EditableInputButtons extends React.Component {

    constructor(props) {
        super(props);
    }

    getVisibility() {
        if (this.props.visible)
            return '';
        else
            return 'none';
    } 

    render() {
        return (
            <div id={this.props.id} ref='editableButtons' className='editableInputPanel' style={{ left: this.props.left + 'px', right: this.props.right + 'px', display: this.getVisibility() }} tabIndex="-1" >
                <button className='btn btn-outline-secondary btn-sm editableInputButton mr-1' onMouseDown={this.props.onCancelClick} tabIndex="-1">
                    <Octicon icon={getIconByName('x')} ariaLabel='Cancel' tabIndex="-1" /></button>
                <button className='btn btn-outline-success btn-sm editableInputButton' onClick={this.props.onSaveClick} tabIndex="-1">
                    <Octicon icon={getIconByName('check')} ariaLabel='Submit' tabIndex="-1" /></button>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Controls/EditableInputButtons.js